import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {KnockoutFieldModel} from "../../../../core/components/knockout-field/knockout-field.model";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {RequestService} from "../../../../core/services/request/request.service";
import {FieldsSettingsModel} from "@syncfusion/ej2-navigations/src/treeview/treeview-model";
import {DragAndDropEventArgs, NodeSelectEventArgs} from "@syncfusion/ej2-navigations/src/treeview/treeview";
import {FieldSettingsModel} from "@syncfusion/ej2-lists/src/list-view/list-view-model";
import {extend, closest, remove, addClass, Internationalization, removeClass, createElement} from "@syncfusion/ej2-base";
import {ListView} from "@syncfusion/ej2-angular-lists";
import {TreeView} from "@syncfusion/ej2-angular-navigations";
import {SelectEventArgs} from "@syncfusion/ej2-lists/src/list-view/list-view";
import {ProgressDialogComponent} from "../../../../core/components/progress-dialog/progress-dialog.component";
import {InternationalizationService} from "../../../../core/services/internationalization/internationalization.service";

enum CreateTransformMapMode {
  CreateTransformMap,
  CreateTransformMapSuccess,
}

enum CreateTransformMapKo {
  Name,
  Source,
  Target,
  Transform,
  PreProcess,
  PostProcess,
  Mapping,
  ImportData
}

@Component({
  selector: 'sb-create-transform-map',
  templateUrl: './create-transform-map.component.html',
  styleUrls: ['./create-transform-map.component.scss']
})
export class CreateTransformMapComponent implements OnInit, OnDestroy {

  CreateTransformMapMode = CreateTransformMapMode; // Needed to access enum in the template
  CreateTransformMapKo = CreateTransformMapKo; // Needed to access enum in the template

  SYSTEM_FIELDS = ["CreatedBy", "CreatedOn", "UpdatedBy", "UpdatedOn", "SID", "Version", "TableClass", "id", "Application"];

  NONE_FIELD = " [none] ";

  page: CreateTransformMapMode = CreateTransformMapMode.CreateTransformMap;

  // Set up a mechanism for us to communicate with the child components (e.g. to ask for validation)
  eventsSubject: Subject<any> = new Subject<any>();

  // Progress dialog

  progressTitle = "Creating transform map";
  progressTopic = "create_transform_map.create";
  progressAutoClose = true;
  @ViewChild("progressDialog") progressDialog: ProgressDialogComponent;

  // Modal

  @ViewChild('selectionDialog') ejDialog: DialogComponent;

  public visible = false;

  public position: any = {X: 'center', Y: 'center'};

  public buttons: ButtonPropsModel[] = [
    {
      'click': this.hideDialog.bind(this, false),
      buttonModel: {
        content: 'Cancel',
      }
    },
    {
      'click': this.hideDialog.bind(this, true),
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      }
    },
  ];

  @Input()
  dialogTitle: string = "";

  @Input()
  autoClose: boolean = true;

  minHeight = 600;

  height = 600;

  width = 900;

  whichDialog: CreateTransformMapKo;

  ///

  importState = {
    importName: "",
    importDescription: "",
    importSourceTable: "",
    importSourceTableName: "",
    importSourceTableImpTmpName: "",
    importTargetTable: "",
    importTargetTableName: "",
    importTransformTable: "",
    importTransformTableName: "",
    importClearProcessingStatus: false,
    importPreProcess: "",
    importPostProcess: "",
    importMappings: [],
  };

  importStateModal = {
    importName: "",
    importDescription: "",
    importSourceTable: "",
    importSourceTableName: "",
    importSourceTableImpTmpName: "",
    importTargetTable: "",
    importTargetTableName: "",
    importTransformTable: "",
    importTransformTableName: "",
    importClearProcessingStatus: false,
    importPreProcess: "",
    importPostProcess: "",

    importMappingId: "",
    importMappingName: "",
    importMappingType: "",
    importMappingSourceField: "",
    importMappingTargetField: "",
    importMappingPrimaryKey: false,
    importMappingLookupTable: "",
    importMappingLookupField: "",
    importMappingScript: "",
  };

  tableList: any[] = [];

  ///

  toggleKnockoutField = true;
  toggleKnockoutFieldLookupField = true;

  responseData;

  ///

  @ViewChild('sourceFieldTreeView')
  public fieldTreeView: TreeView;

  @ViewChild('mappingListView')
  public mappingListView: ListView;

  public mappingListViewId: number = 1;

  public sourceFieldViewData = [];
  public targetFieldViewData = [];

  sourceFieldsViewFields: FieldsSettingsModel = {dataSource: this.sourceFieldViewData, id: 'id', text: 'text'};
  targetFieldsViewFields: FieldsSettingsModel = {dataSource: this.targetFieldViewData, id: 'id', text: 'text'};

  mappingsViewFields: FieldSettingsModel = {id: 'id', text: 'text', sortBy: 'Ascending'};

  mappingsViewDataSource: any[] = [];

  mappingsViewData = [];

  ///

  importNameConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Name",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: true,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "textfield",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      // this.importStateTemp.importName = value || "";
      this.importState.importName = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      // this.importStateTemp.importName = value || "";
      this.importState.importName = value || "";
    }
  };

  importDescriptionConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Description",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "textfield",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      // this.importStateTemp.importDescription = value || "";
      this.importState.importDescription = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      // this.importStateTemp.importDescription = value || "";
      this.importState.importDescription = value || "";
    }
  };

  importTransformTableConfig: KnockoutFieldModel = {
    name: "ImportTransform",
    i18nKey: "Import transform",
    datatype: 'reference',
    availableValues: [],
    referenceTable: "ImportTransform",
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "onetoone",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importTransformTable = value || "";
      this.importStateModal.importTransformTableName = displayValue || "";
    },
  };

  importSourceTableConfig: KnockoutFieldModel = {
    name: "ImportTable",
    i18nKey: "Staging table",
    datatype: 'reference',
    availableValues: [],
    referenceTable: "ImportTable",
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "onetoone",
    rendererProperties: {
      "dropdown.displayFields": "Name:6,Table:6",
      "dropdown.selectionDisplayFields": "Name",
    },
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importSourceTable = value || "";
      this.importStateModal.importSourceTableName = displayValue || "";
    },
  };

  importTargetTableConfig: KnockoutFieldModel = {
    name: "ImportTargetTable",
    i18nKey: "Target table",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importTargetTable = value || "";
      this.importStateModal.importTargetTableName = value || "";
    },
  };

  importClearProcessingStatusConfig: KnockoutFieldModel = {
    name: 'Boolean',
    i18nKey: "Clear processing status?",
    datatype: 'boolean',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "switch",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      this.importStateModal.importClearProcessingStatus = value || false;
    },
  };

  importPreProcessConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Preprocessing script",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "code",
    rendererProperties: {
      "code.mode": "server-script",
    },
    valueChangeCallback: (value) => {
      this.importStateModal.importPreProcess = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      this.importStateModal.importPreProcess = value || "";
    }
  };

  importPostProcessConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Postprocessing script",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "code",
    rendererProperties: {
      "code.mode": "server-script",
    },
    valueChangeCallback: (value) => {
      this.importStateModal.importPostProcess = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      this.importStateModal.importPostProcess = value || "";
    }
  };

  ///

  importMappingNameConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Name",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "textfield",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      this.importStateModal.importMappingName = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      this.importStateModal.importMappingName = value || "";
    }
  };

  importMappingTypeConfig: KnockoutFieldModel = {
    name: "ImportMappingType",
    i18nKey: "Type",
    datatype: 'choice',
    availableValues: [
      {value: 'copy', displayValue: 'Copy', i18nKey: 'Copy'},
      {value: 'lookup', displayValue: 'Lookup', i18nKey: 'Lookup'},
      {value: 'transform', displayValue: 'Transform', i18nKey: 'Transform'},
    ],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importMappingType = value || "";
    },
  };

  importMappingSourceFieldConfig: KnockoutFieldModel = {
    name: "ImportMappingSourceField",
    i18nKey: "Source field",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importMappingSourceField = value || "";
    },
  };

  importMappingTargetFieldConfig: KnockoutFieldModel = {
    name: "ImportMappingTargetField",
    i18nKey: "Target field",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importMappingTargetField = value || "";
    },
  };

  importMappingPrimaryKeyConfig: KnockoutFieldModel = {
    name: 'Boolean',
    i18nKey: 'Primary key',
    datatype: 'boolean',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "switch",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      if (value != undefined) {
        this.importStateModal.importMappingPrimaryKey = Boolean(value) || false;
      }
    },
  };

  importMappingLookupTableConfig: KnockoutFieldModel = {
    name: "ImportTargetTable",
    i18nKey: "Lookup table",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      if (value !== this.importStateModal.importMappingLookupTable) {
        this.importStateModal.importMappingLookupTable = value || "";
        this.importMappingLookupFieldConfig.availableValues = this.getFieldAvailableValues(this.getFields(this.importStateModal.importMappingLookupTable));
        this.importMappingLookupFieldConfig.data.answer = {value: null, displayValue: null};
        this.toggleKnockoutFields('toggleKnockoutFieldLookupField');
      }
    },
  };

  importMappingLookupFieldConfig: KnockoutFieldModel = {
    name: "ImportMappingTargetField",
    i18nKey: "Lookup field",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'sync', displayValue: 'Sync', i18nKey: 'Sync'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value, displayValue) => {
      this.importStateModal.importMappingLookupField = value || "";
    },
  };

  importMappingScriptConfig: KnockoutFieldModel = {
    name: 'String',
    i18nKey: "Transform script",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null, // null | {value?: string, displayValue?: string };
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: {
        value: null,
        displayValue: null
      }, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "code",
    rendererProperties: {
      "code.mode": "server-script",
    },
    valueChangeCallback: (value) => {
      this.importStateModal.importMappingScript = value || "";
    },
    keyupEventCallback: (fieldViewModel, event) => {
      const value = event.target.value;
      this.importStateModal.importMappingScript = value || "";
    }
  };

  ///

  constructor(private requestService: RequestService,
              private i18nService: InternationalizationService) {
  }

  async ngOnInit() {

    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }

    // Mark as import page
    document.getElementById("detailMain")?.classList?.add("sb-import-page-content");

    // Populate table list
    const response: any = await this.requestService.createRequest()
      .controller("servicely.core.Import")
      .method("getTableList")
      .execute();

    this.tableList = response.data.map((e) => {
      return {
        value: e.value,
        displayValue: e.value,
        i18nKey: e.i18nKey,
        id: e.id
      };
    });
  }

  ngOnDestroy(): void {
    document.getElementById("detailMain")?.classList?.remove("sb-import-page-content");
  }

  async submitCreate() {

    await this.eventsSubject.next("validate");

    let validationFailed = false;
    if (this.importNameConfig && !this.importState.importName) {
      validationFailed = true;
    }

    if (!validationFailed) {
      await this.progressDialog.showDialog();

      const data = {
        name: this.importState.importName,
        description: this.importState.importDescription,
        postProcessingScript: this.importState.importPostProcess,
        preProcessingScript: this.importState.importPreProcess,
        resetProcessedRecords: this.importState.importClearProcessingStatus,
        target: this.importState.importTargetTable,
        source: this.importState.importSourceTable,
        nextTransform: this.importState.importTransformTable,
        mappings: this.importState.importMappings
      };

      try {
        const response: any = await this.requestService.createRequest()
          .controller("servicely.core.Import")
          .method("createTransformMap")
          .data(data)
          .execute();

        this.responseData = response.data;

        if (this.responseData && this.responseData.success) {
          this.page = CreateTransformMapMode.CreateTransformMapSuccess;
        }
      } catch (e) {
        this.responseData = { success: false, error: e };
      } finally {
        this.progressDialog.hideDialog();
      }

    }

  }

  buttonLabel(key: string): string {
    return this.i18nService.getMessage(key);
  }

  public closeDialog(args: any) {
    this.visible = false;
    this.resetDimensions();
  }

  public async showDialog(which: CreateTransformMapKo, data?: any) {

    if (which == CreateTransformMapKo.Name) {
      this.dialogTitle = "Edit name and description";
      this.importStateModal.importName = this.importState.importName;
      this.importStateModal.importDescription = this.importState.importDescription;
    } else if (which == CreateTransformMapKo.Source) {
      this.dialogTitle = "Choose staging table";
      this.importStateModal.importSourceTable = this.importState.importSourceTable;
      this.importStateModal.importSourceTableName = this.importState.importSourceTableName;
    } else if (which == CreateTransformMapKo.Target) {
      this.dialogTitle = "Choose target table";
      this.importStateModal.importTargetTable = this.importState.importTargetTable;
      this.importStateModal.importTargetTableName = this.importState.importTargetTableName;

      this.importTargetTableConfig.availableValues = this.tableList;

    } else if (which == CreateTransformMapKo.Transform) {
      this.dialogTitle = "Choose next transform";
      this.importStateModal.importTransformTable = this.importState.importTransformTable;
      this.importStateModal.importTransformTableName = this.importState.importTransformTableName;
    } else if (which == CreateTransformMapKo.PreProcess) {
      this.dialogTitle = "Edit preprocess script";
      this.importStateModal.importPreProcess = this.importState.importPreProcess;
    } else if (which == CreateTransformMapKo.PostProcess) {
      this.dialogTitle = "Edit postprocess script";
      this.importStateModal.importPostProcess = this.importState.importPostProcess;
    } else if (which == CreateTransformMapKo.Mapping) {
      this.dialogTitle = "Edit transform mapping";
      this.importStateModal.importMappingId = data.id;
      this.importStateModal.importMappingName = data.name;
      this.importStateModal.importMappingType = data.type;
      this.importStateModal.importMappingSourceField = data.sourceField;
      this.importStateModal.importMappingTargetField = data.targetField;
      this.importStateModal.importMappingPrimaryKey = data.primaryKey;
      this.importStateModal.importMappingLookupTable = data.lookupTable;
      this.importStateModal.importMappingLookupField = data.lookupField;
      this.importStateModal.importMappingScript = data.script;

      this.importMappingNameConfig.data.answer = {
        value: this.importStateModal.importMappingName,
        displayValue: this.importStateModal.importMappingName,
      };
      this.importMappingTypeConfig.data.answer = {
        value: this.importStateModal.importMappingType,
        displayValue: this.findDisplayValueByValue(this.importMappingTypeConfig, this.importStateModal.importMappingType),
      };
      this.importMappingSourceFieldConfig.data.answer = {
        value: this.importStateModal.importMappingSourceField,
        displayValue: this.importStateModal.importMappingSourceField,
      };
      this.importMappingTargetFieldConfig.data.answer = {
        value: this.importStateModal.importMappingTargetField,
        displayValue: this.importStateModal.importMappingTargetField,
      };
      this.importMappingPrimaryKeyConfig.data.answer = {
        value: this.importStateModal.importMappingPrimaryKey,
        displayValue: `${this.importStateModal.importMappingPrimaryKey}`,
      } as any;
      this.importMappingLookupTableConfig.data.answer = {
        value: this.importStateModal.importMappingLookupTable,
        displayValue: this.importStateModal.importMappingLookupTable,
      };
      this.importMappingLookupFieldConfig.data.answer = {
        value: this.importStateModal.importMappingLookupField,
        displayValue: this.importStateModal.importMappingLookupField,
      };
      this.importMappingScriptConfig.data.answer = {
        value: this.importStateModal.importMappingScript,
        displayValue: this.importStateModal.importMappingScript,
      };

      this.importMappingSourceFieldConfig.availableValues = this.getFieldAvailableValues(this.getFields(this.getSourceImpTmpTable( this.importStateModal.importSourceTable), [this.NONE_FIELD]));
      this.importMappingTargetFieldConfig.availableValues = this.getFieldAvailableValues(this.getFields(this.importStateModal.importTargetTableName));
      this.importMappingLookupTableConfig.availableValues = this.tableList;
      this.importMappingLookupFieldConfig.availableValues = this.getFieldAvailableValues(this.getFields(this.importStateModal.importMappingLookupTable));
    }

    this.whichDialog = which;

    this.toggleKnockoutFields('toggleKnockoutField');

    this.ejDialog.show();
    this.visible = true;
  }

  public hideDialog(save: boolean) {

    if (save) {

      // TODO: do this more cleanly - validate required fields
      this.eventsSubject.next("validate");

      if (this.whichDialog == CreateTransformMapKo.Name) {
        this.importState.importName = this.importStateModal.importName;
        this.importState.importDescription = this.importStateModal.importDescription;
      } else if (this.whichDialog == CreateTransformMapKo.Source) {

        if (this.importState.importSourceTable !== this.importStateModal.importSourceTable) {
          this.importState.importSourceTable = this.importStateModal.importSourceTable;
          this.importState.importSourceTableName = this.importStateModal.importSourceTableName;

          if (!this.importState.importSourceTable) {
            this.sourceFieldViewData = [];
          } else {
            const tabTable = this.getSourceImpTmpTable( this.importState.importSourceTable);
            if (tabTable) {
              const fields = this.getFields(tabTable, [this.NONE_FIELD]);
              this.sourceFieldViewData = fields.map((e) => {
                return {
                  text: e,
                  id: e
                };
              });
            } else {
              this.sourceFieldViewData = [];
            }
          }
          this.sourceFieldsViewFields = {dataSource: this.sourceFieldViewData, id: 'id', text: 'text'};
          this.mappingsViewDataSource = [];
        }
      } else if (this.whichDialog == CreateTransformMapKo.Target) {

        if (this.importState.importTargetTable !== this.importStateModal.importTargetTable) {
          this.importState.importTargetTable = this.importStateModal.importTargetTable;
          this.importState.importTargetTableName = this.importStateModal.importTargetTableName;

          if (!this.importState.importTargetTable) {
            this.targetFieldViewData = [];
          } else {
            const fields = this.getFields(this.importState.importTargetTable);
            this.targetFieldViewData = fields.map((e) => {
              return {
                text: e,
                id: e
              };
            });
          }

          if (!this.importState.importTargetTable) {
            this.mappingsViewDataSource = [];
          } else {
            const fields = this.getFields(this.importState.importTargetTableName);
            this.mappingsViewData = fields;
          }

          this.targetFieldsViewFields = {dataSource: this.targetFieldViewData, id: 'id', text: 'text'};
          this.mappingsViewDataSource = [];
        }
      } else if (this.whichDialog == CreateTransformMapKo.Transform) {
        this.importState.importTransformTable = this.importStateModal.importTransformTable;
        this.importState.importTransformTableName = this.importStateModal.importTransformTableName;
        this.importState.importClearProcessingStatus = this.importStateModal.importClearProcessingStatus;
      } else if (this.whichDialog == CreateTransformMapKo.PreProcess) {
        this.importState.importPreProcess = this.importStateModal.importPreProcess;
      } else if (this.whichDialog == CreateTransformMapKo.PostProcess) {
        this.importState.importPostProcess = this.importStateModal.importPostProcess;
      } else if (this.whichDialog == CreateTransformMapKo.Mapping) {
        const newMapping = {
          id: this.importStateModal.importMappingId,
          text: this.importStateModal.importMappingSourceField,
          name: this.importStateModal.importMappingName,
          type: this.importStateModal.importMappingType,
          sourceField: this.importStateModal.importMappingSourceField,
          targetField: this.importStateModal.importMappingTargetField,
          primaryKey: this.importStateModal.importMappingPrimaryKey,
          lookupTable: this.importStateModal.importMappingLookupTable,
          lookupField: this.importStateModal.importMappingLookupField,
          script: this.importStateModal.importMappingScript,
        };
        const existingMappingIdx = this.importState.importMappings.findIndex((e) => e.id === newMapping.id);
        if (existingMappingIdx !== -1) {
          this.importState.importMappings.splice(existingMappingIdx, 1, newMapping);
        } else {
          this.importState.importMappings.push(newMapping);
        }
        const dataSource: any[] = this.mappingListView.dataSource as any[];
        const existingListViewIdx = dataSource.findIndex((e) => e.id === newMapping.id);
        if (existingMappingIdx !== -1) {
          dataSource.splice(existingListViewIdx, 1, newMapping);
        } else {
          dataSource.push(newMapping);
        }
        dataSource.sort((a, b) => (a.text.localeCompare(b.text)));
        this.mappingListView.refresh();
      }
    }

    this.ejDialog.hide();
    this.visible = false;
    this.resetDimensions();
  }

  public destroyDialog() {
    this.ejDialog.destroy();
    this.visible = false;
    this.resetDimensions();
  }

  public onTitle($event) {
    this.dialogTitle = $event;
  }

  resetDimensions() {
    this.minHeight = 600;
    this.height = 600;
    this.width = 900;
  }

  onDragDragging(e: DragAndDropEventArgs) {
  }

  onDragStop(e: DragAndDropEventArgs) {
    // Block dropping on same tree view
    const parents = [];
    let parent = e.target;
    while (parent) {
      parents.push(parent);
      parent = parent.parentElement;
    }
    if (parents.includes(e.draggedParentNode)) {
      let draggingItem = document.getElementsByClassName("e-drop-in");
      if (draggingItem.length == 1) {
        draggingItem[0].classList.add('e-no-drop');
      }
      e.cancel = true;
      return;
    }

    let targetEle: any = closest(e.target, '.e-droppable');
    targetEle = targetEle ? targetEle : e.target;
    if (targetEle && targetEle.classList.contains('sb-ctm-custom-list')) {
      e.cancel = true;
      let newData: { [key: string]: Object }[] = [];
      if (e.draggedNode.classList.contains('e-active')) {
        const dragNode: any = closest(e.draggedNode, '.e-treeview');
        const selNodes = dragNode.ej2_instances[0].selectedNodes;
        for (let i: number = 0, len: number = selNodes.length; i < len; i++) {
          let nodeEle: Element = document.querySelector('[data-uid="' + selNodes[i] + '"]').querySelector('.e-list-text');
          let nodeText: string = nodeEle.textContent;
          let newMapping: { [key: string]: Object } = {
            id: 'l' + this.mappingListViewId,
            text: nodeText,
            name: "",
            type: "copy",
            sourceField: nodeText,
            targetField: "",
            primaryKey: false,
            lookupTable: "",
            lookupField: "",
            script: "",
          };
          this.mappingListViewId++;
          newData.push(newMapping);
          this.importState.importMappings.push(newMapping);
        }
      } else {
        let text: string = 'text';
        let nodeText: string = e.draggedNodeData[text] as string;
        let newMapping: { [key: string]: Object } = {
          id: 'l' + this.mappingListViewId,
          text: nodeText,
          name: "",
          type: "copy",
          sourceField: nodeText,
          targetField: "",
          primaryKey: false,
          lookupTable: "",
          lookupField: "",
          script: "",
        };
        this.mappingListViewId++;
        newData.push(newMapping);
        this.importState.importMappings.push(newMapping);
      }
      this.mappingListView.addItem(newData, undefined);
      (this.mappingListView.dataSource as any[]).sort((a, b) => a.text.localeCompare(b.text));
      this.mappingListView.refresh();
    }
  }

  onNodeSelecting(e: NodeSelectEventArgs) {
    e.cancel = true;
  }

  onSelect(e: SelectEventArgs) {
    e.item.classList.remove('e-active');
  }

  onMappingDelete(e: MouseEvent) {
    const node: Element = closest(e.target as HTMLElement, 'li');
    this.mappingListView.removeItem(node);
    (this.mappingListView.dataSource as any[]).sort((a, b) => a.text.localeCompare(b.text));
    this.mappingListView.refresh();
    const data = this.mappingListView.findItem(node) as any; // TODO: check this as the declared return type does not match the returned object.
    if (data) {
      const idx = this.importState.importMappings.findIndex((e) => e.id == data.id);
      if (idx !== -1) {
        this.importState.importMappings.splice(idx, 1);
      }
    }
  }

  findDisplayValueByValue(config: KnockoutFieldModel, value: string): string {
    return config.availableValues.find((e) => e.value === value)?.displayValue || "";
  }

  getFields(table: string, extraFields: string[] = []): string[] {
    let result = [];
    if (table) {
      const tableDefinition = (window as any).TableManager.getTableDefinition(table);
      if (tableDefinition) {
        const fields = Object.values(tableDefinition.getFields()).filter((f: any) => !f._data._fieldName.startsWith("_") && !this.SYSTEM_FIELDS.includes(f._data._fieldName)).map((f: any) => f._data._fieldName);
        const relationships = Object.values(tableDefinition.getRelations()).filter((f: any) => !f._data._relationshipName.startsWith("_") && f._data._relationshipType !== 'MANY_TO_ONE' && !this.SYSTEM_FIELDS.includes(f._data._relationshipName) && !fields.includes(f._data._relationshipName)).map((f: any) => f._data._relationshipName);
        result = [...fields, ...relationships, ...extraFields];
      }
    }
    return result;
  }

  getFieldAvailableValues(fields: string[]): any[] {
    return fields.map((e) => {
      return {
        value: e,
        displayValue: e,
        i18nKey: e,
      };
    });
  }

  getSourceImpTmpTable(tableId: string) {
    let result = null;
    if (tableId) {
      const tab = (window as any).Table("ImportTable", tableId);
      if (tab) {
        result = tab.Table();
      }
    }
    return result;
  }


  toggleKnockoutFields(which : string) {
    this[which] = false;
    setTimeout(() => {
      this[which] = true;
    }, 0);
  }
}
